import { createI18n } from "vue-i18n";
import { Locale } from "vant";
import { getLocalData, setLocalData } from "@/utils/storage";
import { enum_base_language } from "@/enum/base";

import enUS from "vant/es/locale/lang/en-US";
import jaJP from "vant/es/locale/lang/ja-JP";
import esES from "vant/es/locale/lang/es-ES";
import svSE from "vant/es/locale/lang/sv-SE";
import itIT from "vant/es/locale/lang/it-IT";
import deDE from "vant/es/locale/lang/de-DE";
import nbNO from "vant/es/locale/lang/nb-NO";
import ruRU from "vant/es/locale/lang/ru-RU";
import frFR from "vant/es/locale/lang/fr-FR";

import enUSLocale from "./locales/en-US";
import jsJPLocale from "./locales/js-JP";
import esESLocale from "./locales/es-ES";
import svSELocale from "./locales/sv-SE";
import itITLocale from "./locales/it-IT";
import deDELocale from "./locales/de-DE";
import nbNOLocale from "./locales/nb-NO";
import ruRULocale from "./locales/ru-RU";
import huHULocale from "./locales/hu-HU";
import plPLLocale from "./locales/pl-PL";
import skSKLocale from "./locales/sk-SK";
import frFRLocale from "./locales/fr-FR";

export type LanguageProps = {
	name: string;
	code: enum_base_language;
};

// 语言
export const Languages: LanguageProps[] = [
	{
		name: "🇺🇸 English",
		code: enum_base_language["en-US"]
	},
	{
		name: "🇪🇸 Español",
		code: enum_base_language["es-ES"]
	},
	{
		name: "🇫🇷 Français",
		code: enum_base_language["fr-FR"]
	},
	{
		name: "🇯🇵 日本語",
		code: enum_base_language["ja-JP"]
	},
	{
		name: "🇸🇪 Svenska",
		code: enum_base_language["sv-SE"]
	},
	{
		name: "🇮🇹 Italiano",
		code: enum_base_language["it-IT"]
	},
	{
		name: "🇩🇪 Deutsch",
		code: enum_base_language["de-DE"]
	},
	{
		name: "🇳🇴 Norsk",
		code: enum_base_language["nb-NO"]
	},
	{
		name: "🇷🇺 Русский",
		code: enum_base_language["ru-RU"]
	},
	{
		name: "🇭🇺 Magyar",
		code: enum_base_language["hu-HU"]
	},
	{
		name: "🇵🇱 Polski",
		code: enum_base_language["pl-PL"]
	},
	{
		name: "🇸🇰 Slovenčina",
		code: enum_base_language["sk-SK"]
	}
];
const LANGUAGE_LOCAL_KEY = "LANGUAGE_LOCAL_KEY";

const messages: Record<enum_base_language, any> = {
	"en-US": Object.assign({}, enUS, enUSLocale),
	"fr-FR": Object.assign({}, frFR, frFRLocale),
	"ja-JP": Object.assign({}, jaJP, jsJPLocale),
	"es-ES": Object.assign({}, esES, esESLocale),
	"sv-SE": Object.assign({}, svSE, svSELocale),
	"it-IT": Object.assign({}, itIT, itITLocale),
	"de-DE": Object.assign({}, deDE, deDELocale),
	"nb-NO": Object.assign({}, nbNO, nbNOLocale),
	"ru-RU": Object.assign({}, ruRU, ruRULocale),
	"hu-HU": Object.assign({}, enUS, huHULocale),
	"pl-PL": Object.assign({}, enUS, plPLLocale),
	"sk-SK": Object.assign({}, enUS, skSKLocale)
};

/**
 * 修改语言
 * @description 1. i18n的修改语言在`setup`才能生效.
 * 2. 在`setup`调用修改再调用`store/global -> setLanguage`函数修改`vant`语言和缓存语言.
 * 3. 如果需要重新请求，手动刷新页面`window.location.reload()`
 * @param code 语言代码
 */
export const changeLanguage = (code: enum_base_language) => {
	Locale.use(code, messages[code]);
	setLocalData(LANGUAGE_LOCAL_KEY, code);
};

/**
 * 获取当前语言
 * @returns code 语言代码
 */
export const getCurrentLocale = (): enum_base_language => {
	const currentLocale = getLocalData(LANGUAGE_LOCAL_KEY);
	if (currentLocale && Languages.some(it => it.code === currentLocale)) {
		return currentLocale;
	} else {
		return Languages[0].code;
	}
};

// 初始化语言
const currentLocale = getCurrentLocale();
changeLanguage(currentLocale);

const i18n = createI18n({
	allowComposition: true,
	legacy: false,
	locale: currentLocale, // 默认显示语言
	fallbackLocale: enum_base_language["en-US"],
	messages
});

export default i18n;
